// routing
import routes from 'routes';

// project imports
import Locales from 'ui-component/Locales';
import NavigationScroll from 'layout/NavigationScroll';
import RTLLayout from 'ui-component/RTLLayout';
import Snackbar from 'ui-component/extended/Snackbar';
import Backdrop from 'ui-component/extended/Backdrop';
import ErrorSnackbar from 'ui-component/extended/ErrorSnackbar';
import ThemeCustomization from 'themes';
import { createBrowserRouter, RouterProvider, useLocation } from 'react-router-dom';

// auth provider
// import { FirebaseProvider as AuthProvider } from 'contexts/FirebaseContext';
// import { AWSCognitoProvider as AuthProvider } from 'contexts/AWSCognitoContext';
// import { JWTProvider as AuthProvider } from 'contexts/JWTContext';
import { Auth0Provider as AuthProvider } from 'contexts/Auth0Context';
import { WorkspaceProvider } from 'contexts/WorkspaceContext';
import { PermissionProvider } from 'contexts/PermissionContext';

// ==============================|| APP ||============================== //

const App = () => {
    const router = createBrowserRouter(routes);
    
    return (
        <ThemeCustomization>
            {/* RTL layout */}
            <RTLLayout>
                <Locales>
                    <AuthProvider>
                        <WorkspaceProvider>
                            <PermissionProvider>
                                <RouterProvider router={router} />
                                <Snackbar />
                                <Backdrop />
                                <ErrorSnackbar />
                            </PermissionProvider>
                        </WorkspaceProvider>
                    </AuthProvider>
                </Locales>
            </RTLLayout>
        </ThemeCustomization>
    )
};

export default App;
